import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import { T } from "../../components/T";
import { SnackbarContext } from "../../contexts/snackbarContext";
import { useMutation } from "@apollo/client";
import { DELETE_POLESET, POLESETS } from "../../graphql/gqlPoleset";
import { useParams } from "react-router-dom";
import { AreYouSureModal } from "../../modals/AreYouSureModal";

export const DeletePolesetButton = ({ setId }: { setId: string }) => {
  const { userId } = useParams();
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);
  const [open, setOpen] = useState(false);

  const [deletePoleset] = useMutation(DELETE_POLESET, {
    refetchQueries: [{ query: POLESETS, variables: { userId } }],
  });

  const handleDelete = () => {
    deletePoleset({ variables: { id: setId } })
      .then(() => {
        openSuccessSnackbar(<T str="Poleset deleted" />);
      })
      .catch((error: Error) => {
        openErrorSnackbar(error.message || <T str="Something went wrong" />);
      })
      .finally(() => {
        setOpen(false);
      });
  };

  return (
    <>
      <Button
        type="button"
        variant="outlined"
        color="error"
        sx={{
          mt: 3,
          mb: 2,
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        <T str="Delete poleset" />
      </Button>

      <AreYouSureModal
        title={<T str="Delete poleset" />}
        question={
          <T str="Are you sure you want to delete this poleset? This action cannot be undone." />
        }
        confirm={<T str="Delete" />}
        onConfirm={handleDelete}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};
